export enum HoldingGraphType {
    Price = 0,
    Growth = 1
}